import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { toIsoFromDateTimeParts } from '@/common/utils/dateUtils';
import { unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { buildModification } from '@/features/maintenance/features/workflows/features/executionEntry/hooks/useUpdateMaintenanceExecutionEntryEstablishmentAccept';
import { UpdateExecutionEntryEstablishmentAcceptValidationSchema } from '@/features/maintenance/features/workflows/features/executionEntry/schemas/updateExecutionEntryEstablishmentAccept.schema';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseCreateMaintenanceEstablishmentChoiceAuctionEntryExecutionProposalProps {
  auctionEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    UpdateExecutionEntryEstablishmentAcceptValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateMaintenanceEstablishmentChoiceAuctionEntryExecutionProposal = ({
  auctionEntryId,
  options,
}: UseCreateMaintenanceEstablishmentChoiceAuctionEntryExecutionProposalProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceEstablishmentChoiceAuctionEntryProposal'],
    mutationFn: (form) => {
      const startAt = toIsoFromDateTimeParts(
        form.start_at_date,
        form.start_at_time,
        true
      );

      const pieces_modifications_attributes = form.pieces
        .map((piece) => buildModification('objective_piece_id', piece))
        .filter((modification) => modification !== null)

      const activities_modifications_attributes = form.activities
        .map((activity) => buildModification('objective_activity_id', activity))
        .filter((modification) => modification !== null)

      const payload = {
        auction_entry_id: auctionEntryId,
        directive_proposal_content_attributes: {
          start_at: startAt,
          deadline_to_complete_in_days: unFormatUnknownUnit(
            form.deadline_to_complete_in_days
          ),
          pieces_modifications_attributes,
          activities_modifications_attributes,
        },
      };

      return privateAxios.post(`/maintenance/establishment_choice/auction_entry_proposals`, payload);
    },
    ...options
  });
}
